import React from 'react';
import SubSection from 'components/common/section/sub-section/SubSection';
import CertificationCardSidePannel from './CertificationCardSidePanel';
import { Certification } from '../../../utils/certifications';

interface DesignationsProps {
  certifications: Certification[];
}
export const Designations: React.FC<DesignationsProps> = ({
  certifications,
}) => {
  return (
    <div>
      <SubSection title="Designations">
        {certifications.slice(0, 4).map((cert) => (
          <CertificationCardSidePannel
            key={cert.name}
            name={cert.name}
            imageUrl={cert.imageUrl}
          />
        ))}
      </SubSection>
    </div>
  );
};
